<div
  class="solo-new-target"
  [ngStyle]="drawerStyles | theme"
  *transloco="let t; prefix: 'components.solo'"
>
  <div [ngClass]="glowClass"></div>

  <app-nav-button
    icon="close"
    (clickEvent)="onCloseClick()"
    [variant]="drawerConfig.closeButtonInverted ? 'secondary' : 'primary'"
    [size]="drawerConfig.closeButtonSize"
    [ngClass]="drawerConfig.closeButtonPosition"
    [class.close-held]="busy()"
  />

  @if (unavailable(); as reason) {
    <div class="hero">
      <div class="heading" [ngStyle]="headingStyles | theme">
        <app-icon
          icon="target"
          colorCss="--drawer-solo-label-heading-fill"
          sizeCss="--drawer-solo-label-heading-icon-size"
        />
        <span>{{
          reason === "quote-failed" ? t("target-unavailable") : t("stake-unavailable-title")
        }}</span>
      </div>
    </div>

    <div class="checkout" *transloco="let alert; prefix: 'service.alert'">
      @if (reason !== "quote-failed") {
        <div [ngStyle]="bodyStyles | theme">
          {{ t("stake-unavailable-body", { amount: entry()?.primary?.text }) }}
        </div>
      }
      <app-button
        class="play-button"
        stretch="fill"
        size="medium"
        variant="primary"
        [label]="alert('ok-button')"
        (clickEvent)="onCloseClick()"
      />
    </div>
  } @else {
    <div class="hero">
      <div class="heading" [ngStyle]="headingStyles | theme">
        <app-icon
          icon="target"
          colorCss="--drawer-solo-label-heading-fill"
          sizeCss="--drawer-solo-label-heading-icon-size"
        />
        <span>{{ t("new-target-title") }}</span>
      </div>
      <app-solo-stat class="target-box" tokens="drawer-solo-stat" [label]="t('target')">
        <div class="target-line">
          <span class="target" [ngStyle]="targetStyles | theme">{{ target() }}</span>
          <span [ngStyle]="unitStyles | theme">{{ t("points-unit") }}</span>
        </div>
      </app-solo-stat>
    </div>

    <div class="checkout" *transloco="let common; prefix: 'components.pay-drawer-common'">
      <div [ngStyle]="bodyStyles | theme">{{ t("new-target-body", { target: target() }) }}</div>
      @if (paid()) {
        <app-button
          *transloco="let alert; prefix: 'service.alert'"
          class="play-button"
          stretch="fill"
          size="medium"
          variant="primary"
          [label]="alert('continue-button')"
          [disabled]="payDisabled()"
          [loading]="busy()"
          (clickEvent)="onPayClick()"
        />
      } @else {
        <app-currency-button
          class="play-button"
          stretch="fill"
          size="medium"
          [prefix]="common('pay-button-prefix')"
          [suffix]="common('pay-button-suffix')"
          [primaryAmount]="entry()?.primary"
          [hasSecondaryCurrency]="hasSecondaryCurrency()"
          [secondaryAmount]="entry()?.secondary"
          [disabled]="payDisabled()"
          [loading]="busy()"
          (clickEvent)="onPayClick()"
        />
      }
    </div>
  }
</div>
